export const getPagination = ({ pagination }) => pagination;

export const getPayLoadPlanStructure = state => {
  var recursive = plan_structures => {
    var response = [];
    plan_structures.forEach(plan_structure => {
      if (!plan_structure.name || !String(plan_structure.name).trim()) {
        return;
      }
      if (Array.isArray(plan_structure.children)) {
        plan_structure.children = recursive(plan_structure.children);
      }
      response.push(plan_structure);
    });
    return response;
  };
  return recursive(state.tree_plan_structure);
};

export const getTreePlanStructureLength = state => {
  var recursive = plan_structures => {
    var response = plan_structures.length;
    if (plan_structures.length) {
      plan_structures.forEach(plan_structure => {
        if (Array.isArray(plan_structure.children)) {
          response += recursive(plan_structure.children);
        }
      });
    }
    return response;
  };

  return state.tree_plan_structure ? recursive(state.tree_plan_structure) : 0;
};

export const getStructureDetailText = state => {
  const tree = state.tree_plan_structure;
  const levels = state.strategic_plan?.config?.plan_structure?.levels || [];
  if (!Array.isArray(tree) || tree.length === 0) return "";

  const firstLevelCount = tree.length;
  const secondLevelCount = tree.reduce(
    (acc, n) => acc + (Array.isArray(n.children) ? n.children.length : 0),
    0
  );

  const pluralize = (word) =>
    !word ? "" : word.endsWith("z") ? `${word.slice(0, -1)}zes` : `${word}s`;
  const firstLabel = levels[0] ? pluralize(levels[0]) : "itens";
  const secondLabel = levels[1] ? pluralize(levels[1]) : "subitens";

  const parts = [];
  if (firstLevelCount > 0) parts.push(`${firstLevelCount} ${firstLabel}`);
  if (secondLevelCount > 0) parts.push(`${secondLevelCount} ${secondLabel}`);
  return parts.join(" · ");
};
